'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M511.9 19.3c-1.9-9.5-9.3-16.9-18.8-18.8-45-9-114-14.7-180.7 19.7-40 20.7-77.3 54.8-107.7 107.8l-81.1 0c-16.9 0-32.5 8.8-41.2 23.3L29.5 239.5C16.7 260.9 32.1 288 56.9 288l103.5 0c35.3 0 64 28.7 64 64l0 103.5c0 24.9 27.1 40.2 48.5 27.4L361.1 430c14.5-8.7 23.3-24.3 23.3-41.2l0-81.1c53.1-30.4 87.2-67.7 107.8-107.7 34.4-66.7 28.7-135.7 19.7-180.7zM336.4 331.1l0 57.8-64 38.4 0-74.5c23.3-6.4 44.6-13.6 64-21.6zm-74-25.4c-11.2-24.6-31-44.5-55.7-55.7 30.6-109.9 79.9-162.5 127.7-187.2 45.9-23.7 94.6-23.8 133.2-18.1 5.8 38.6 5.6 87.3-18.1 133.2-24.7 47.8-77.3 97.1-187.2 127.7zM159.7 240l-74.5 0 38.4-64 57.8 0c-8 19.4-15.2 40.7-21.6 64zm248.7-96a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM152.8 473.6c31.5-31.5 31.5-82.5 0-114s-82.5-31.5-114 0c-31.3 31.3-37.5 92-38.3 126.4-.4 14.6 11.2 26.2 25.9 25.9 34.5-.8 95.1-7 126.4-38.3zm-40.6-32c-10.1 10.1-28.5 13-41.3 13.7-8 .5-14.3-5.9-13.9-13.9 .7-12.8 3.7-31.2 13.7-41.3 11.4-11.4 30-11.4 41.4 0s11.4 30 0 41.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;